import { useEffect, useState } from 'react';
import {
    Button,
    Typography,
    Grid,
    Box,
    Divider
} from '@mui/material';
import { DataAccordion } from '../../../shared-components/DataAccordion';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import DashboardIntro from './DashboardIntro';
import DataCard from '../../../shared-components/DataCard';
import ScopeOneEmissionsFacilities from './facilities/emissions/scope-one/ScopeOneEmissionsFacilities';
import ScopeTwoEmissionsFacilities from './facilities/emissions/scope-two/ScopeTwoEmissionsFacilities';
import ScopeThreeEmissionsFacilities from './facilities/emissions/scope-three/ScopeThreeEmissionsFacilities';
import ScopeOneEmissionsOverview from './overview/emissions/scope-one/ScopeOneEmissionsOverview';
import ScopeTwoEmissionsOverview from './overview/emissions/scope-two/ScopeTwoEmissionsOverview';
import ScopeThreeEmissionsOverview from './overview/emissions/scope-three/ScopeThreeEmissionsOverview';
import { ScopeOneConsumptionOverview } from './overview/consumption/scope-one/ScopeOneConsumptionOverview';
import { ScopeTwoConsumptionOverview } from './overview/consumption/scope-two/ScopeTwoConsumptionOverview';
import { ScopeThreeConsumptionOverview } from './overview/consumption/scope-three/ScopeThreeConsumptionOverview';
import { ScopeOneConsumptionFacilities } from './facilities/consumption/scope-one/ScopeOneConsumptionFacilities';
import { ScopeTwoConsumptionFacilities } from './facilities/consumption/scope-two/ScopeTwoConsumptionFacilities';
import { ScopeThreeConsumptionFacilities } from './facilities/consumption/scope-three/ScopeThreeConsumptionFacilities';
import DashboardEmissionsTable from './shared-components/DashboardEmissionsTable';
import { getCompanyEmissionsSummary, getGroupEmissionsSummary } from '../../../../actions/carbonfootprint-rework/07-emission-factors/01-emission-factors';
import ExportCompanyEmissionsOverview from './shared-components/ExportCompanyEmissionsOverview';
import ExportGroupEmissionsOverview from './shared-components/ExportGroupEmissionsOverview';
import ExportCompanyConsumptionOverview from './shared-components/ExportCompanyConsumptionOverview';
import ExportGroupConsumptionOverview from './shared-components/ExportGroupConsumptionOverview';
import { emissionsTableWidth, overviewTypes, scopeOneTitle, scopeThreeTitle, scopeTwoTitle, subAccordionGap, summaryColumns } from './constants/dashboard-constants';
import { getGroups } from '../../../../actions/carbonfootprint-rework/00-base/00-base-actions';


export default function CFDashboard({ userData, isOpen }) {
    const dispatch = useDispatch();
    const [mainAccordion, setMainAccordion] = useState(null);
    const [subAccordion, setSubAccordion] = useState(null);

    // need access to company name for graph display purposes
    // could access from companyData?.company?.name
    const companyName = userData?.carbonFootprintUser?.companyName
    // could access from companyData?.company?.id
    const companyId = userData?.carbonFootprintUser?.companyId

    const [activeGroupId, setActiveGroupId] = useState(null);
    const [activeCompanyId, setActiveCompanyId] = useState(null);
    const [activeGroupYear, setActiveGroupYear] = useState(null);
    const [activeCompanyYear, setActiveCompanyYear] = useState(null);
    const [userCompany, setUserCompany] = useState(null);
    const [companyOverviewType, setCompanyOverviewType] = useState(null)
    const [groupOverviewType, setGroupOverviewType] = useState(null)

    const companyAccordion = 'Company Overview'
    const groupAccordion = 'Group Overview'

    const companyData = useSelector((state) => (state.carbonFootprintBase.userCompanyData?.data))
    const company = companyData?.company

    const years = companyData?.years

    const groups = companyData?.groups
    const groupName = groups?.find((group) => (group.id === activeGroupId))?.name
    const groupArray = groups?.map((group) => (group.name))

    const facilities = groups?.find((group) => (group.id === activeGroupId))?.facilities
    const facilitiesArray = facilities?.map((facility) => (facility.name))

    const companyEmissionsSummaryData = useSelector((state) => state.emissionFactorsReducer?.companyEmissionsSummary?.data)
    const groupEmissionsSummaryData = useSelector((state) => state.emissionFactorsReducer?.groupEmissionsSummary?.data)
    const isLoadingCompanySummary = useSelector((state) => (state.emissionFactorsReducer?.companySummaryLoading))
    const isLoadingGroupSummary = useSelector((state) => (state.emissionFactorsReducer?.groupSummaryLoading))

    const companyEmissionsSummary = []
    const groupEmissionsSummary = []

    companyEmissionsSummaryData?.forEach((dataItem) => {
        const {
            category,
            value,
            unit,
            total,
            groups,
            percent } = dataItem
        companyEmissionsSummary.push({ category: category, value: value, unit: unit, total: total, percent: percent })
        groups.forEach((group) => {
            companyEmissionsSummary.push(group)
            // const { maincategories } = group
            // maincategories?.forEach((mainCategory) => (companyEmissionsSummary.push(mainCategory)))
        })

    })

    groupEmissionsSummaryData?.forEach((dataItem) => {
        const {
            category,
            value,
            unit,
            total,
            // facilities,
            percent } = dataItem
        groupEmissionsSummary.push({ category: category, value: value, unit: unit, total: total, percent: percent })
        // facilities.forEach((group) => (groupEmissionsSummary.push(group)))
    })

    useEffect(() => {
        setMainAccordion(null)
        setSubAccordion(null)
    }, [])

    useEffect(() => {
        if (mainAccordion === companyAccordion && companyOverviewType === 'Emissions') {
            dispatch(getCompanyEmissionsSummary(activeCompanyId, activeCompanyYear))
        }
        else if (mainAccordion === groupAccordion && groupOverviewType === 'Emissions') {
            dispatch(getGroupEmissionsSummary(companyId, activeGroupId, activeGroupYear))
        }

    }, [mainAccordion,
        activeCompanyId,
        activeGroupId,
        activeCompanyYear,
        activeGroupYear,
        companyOverviewType,
        groupOverviewType])

    useEffect(() => {
        setActiveCompanyYear(null)
        setActiveGroupYear(null)
        setActiveCompanyId(null)
        setActiveGroupId(null)
        setCompanyOverviewType(null)
        setGroupOverviewType(null)
    }, [mainAccordion])

    useEffect(() => {
        setSubAccordion(null)
    }, [mainAccordion, groupOverviewType, companyOverviewType, activeGroupId])

    useEffect(() => {
        if (mainAccordion === groupAccordion) {
            dispatch(getGroups(companyId))
            setUserCompany(companyId);
        }
    }, [mainAccordion, companyId]);

    const FlowChart = () => (
        <Box style={{ textAlign: "center" }}>
            <img src={'/vinimark-flow-chart.svg'} alt="Vinimark Flow Chart" style={{ maxWidth: "100%", height: "auto" }} />
        </Box>
    );

    function changeMainAccordion(text) {
        if (mainAccordion !== text) {
            setMainAccordion(text)
            setSubAccordion(null)
        }
        else {
            setMainAccordion(null)
            setSubAccordion(null)
        }
    }

    function changeSubAccordion(text) {
        if (subAccordion !== text) {
            setSubAccordion(text)
        }
        else {
            setSubAccordion(null)
        }
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <DashboardIntro isOpen={isOpen} />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {groups?.length > 1 && <>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="h5">
                        Organisational Hierarchy
                    </Typography>
                    <DataAccordion
                        title={'the Organisational Hierarchy'}
                        show={mainAccordion === 'Organisational Hierarchy'}
                        handleChange={() =>
                            changeMainAccordion('Organisational Hierarchy')}
                    >
                        <FlowChart />
                    </DataAccordion>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="h5">
                        Company Overview
                    </Typography>
                    <DataAccordion title={'the Company Overview'}
                        show={mainAccordion === companyAccordion}
                        handleChange={() => changeMainAccordion(companyAccordion)}
                    >
                        <Box sx={{ width: '100%', display: "flex", flexDirection: 'column', gap: 3 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <DataCard activeId={activeCompanyId} setActiveId={setActiveCompanyId} data={company} company={companyName} groupArray={groupArray} />
                            </Box>
                            {activeCompanyId &&
                                <DashboardSelectionButtons
                                    array={years}
                                    selected={activeCompanyYear}
                                    setSelected={setActiveCompanyYear}
                                    title='Select Year'
                                />
                            }
                            {activeCompanyId && activeCompanyYear &&
                                <DashboardSelectionButtons
                                    array={overviewTypes}
                                    selected={companyOverviewType}
                                    setSelected={setCompanyOverviewType}
                                    title='Select Company Overview Type'
                                />
                            }
                            {activeCompanyId && activeCompanyYear && companyOverviewType === 'Consumption' &&
                                <Grid item sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <Divider />
                                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="h5" component="h5">
                                                {companyName} Consumption Summary for {activeCompanyYear}
                                            </Typography>
                                            <ExportCompanyConsumptionOverview
                                                companyName={companyName}
                                                companyId={companyId}
                                                year={activeCompanyYear}
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: subAccordionGap }}>
                                        <ScopeOneConsumptionOverview
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            year={activeCompanyYear}
                                            company={activeCompanyId}
                                            companyName={companyName}
                                            title={scopeOneTitle}
                                            groupArray={groupArray}
                                        />
                                        <ScopeTwoConsumptionOverview
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            year={activeCompanyYear}
                                            company={activeCompanyId}
                                            companyName={companyName}
                                            title={scopeTwoTitle}
                                            groupArray={groupArray}
                                        />
                                        <ScopeThreeConsumptionOverview
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            year={activeCompanyYear}
                                            company={activeCompanyId}
                                            companyName={companyName}
                                            title={scopeThreeTitle}
                                            groupArray={groupArray}
                                        />
                                    </Box>
                                </Grid>
                            }
                            {
                                activeCompanyId && activeCompanyYear && companyOverviewType === 'Emissions' &&
                                <Grid item sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <Divider />
                                        <Box sx={{ width: emissionsTableWidth, display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="h5" component="h5">
                                                {companyName} Emissions Summary for {activeCompanyYear}
                                            </Typography>
                                            {
                                                !isLoadingCompanySummary &&
                                                <ExportCompanyEmissionsOverview
                                                    companyName={companyName}
                                                    companyId={companyId}
                                                    year={activeCompanyYear} />
                                            }
                                        </Box>
                                        <DashboardEmissionsTable loading={isLoadingCompanySummary} rows={companyEmissionsSummary} columns={summaryColumns} />
                                    </Box>
                                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: subAccordionGap }}>
                                        <ScopeOneEmissionsOverview
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            companyName={companyName}
                                            companyId={activeCompanyId}
                                            year={activeCompanyYear}
                                        />
                                        <ScopeTwoEmissionsOverview
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            companyName={companyName}
                                            companyId={activeCompanyId}
                                            year={activeCompanyYear}
                                        />
                                        <ScopeThreeEmissionsOverview
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            companyName={companyName}
                                            companyId={activeCompanyId}
                                            year={activeCompanyYear}
                                        />
                                    </Box>
                                </Grid>
                            }
                        </Box>
                    </DataAccordion>
                </Box>
                </>}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="h5">
                        Group Overview
                    </Typography>
                    <DataAccordion title={'the Group Overview'}
                        show={mainAccordion === groupAccordion}
                        handleChange={() => changeMainAccordion(groupAccordion)}
                    >
                        <Grid container item xs={12} display="flex" flexDirection='column' gap={3}>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                {groups?.map((group, index) => (
                                    <DataCard key={index} activeId={activeGroupId} setActiveId={setActiveGroupId} data={group} company={companyName} groupArray={groupArray} />
                                )
                                )}
                            </Box>
                            {activeGroupId &&
                                <DashboardSelectionButtons
                                    array={years}
                                    selected={activeGroupYear}
                                    setSelected={setActiveGroupYear}
                                    title='Select Year'
                                />
                            }
                            {activeGroupId && activeGroupYear &&
                                <DashboardSelectionButtons
                                    array={overviewTypes}
                                    selected={groupOverviewType}
                                    setSelected={setGroupOverviewType}
                                    title='Select Group Overview Type'
                                />
                            }
                            {activeGroupId && activeGroupYear && groupOverviewType === 'Consumption' &&
                                <Grid item sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <Divider />
                                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="h5" component="h5">
                                                {groupName} Consumption Summary for {activeGroupYear}
                                            </Typography>
                                            <ExportGroupConsumptionOverview
                                                groupName={groupName}
                                                companyId={companyId}
                                                groupId={activeGroupId}
                                                year={activeGroupYear}
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: subAccordionGap }}>
                                        <ScopeOneConsumptionFacilities
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            company={userCompany}
                                            group={activeGroupId}
                                            year={activeGroupYear}
                                            title={scopeOneTitle}
                                            groupFacilities={facilitiesArray}
                                            groupName={groupName}
                                        />
                                        <ScopeTwoConsumptionFacilities
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            company={userCompany}
                                            group={activeGroupId}
                                            year={activeGroupYear}
                                            title={scopeTwoTitle}
                                            groupFacilities={facilitiesArray}
                                            groupName={groupName}
                                        />
                                        <ScopeThreeConsumptionFacilities
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            company={userCompany}
                                            group={activeGroupId}
                                            year={activeGroupYear}
                                            title={scopeThreeTitle}
                                            groupFacilities={facilitiesArray}
                                            groupName={groupName}
                                        />
                                    </Box>
                                </Grid >
                            }
                            {activeGroupId && activeGroupYear && groupOverviewType === 'Emissions' &&
                                <Grid item sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <Divider />
                                        <Box sx={{ width: emissionsTableWidth, display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="h5" component="h5">
                                                {groupName} Emissions Summary for {activeGroupYear}
                                            </Typography>
                                            {
                                                !isLoadingGroupSummary &&
                                                <ExportGroupEmissionsOverview
                                                    groupName={groupName}
                                                    groupId={activeGroupId}
                                                    companyId={companyId}
                                                    year={activeGroupYear} />
                                            }
                                        </Box>
                                        <DashboardEmissionsTable loading={isLoadingGroupSummary} rows={groupEmissionsSummary} columns={summaryColumns} />
                                    </Box>
                                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: subAccordionGap }}>
                                        <ScopeOneEmissionsFacilities
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            companyId={companyId}
                                            groupId={activeGroupId}
                                            year={activeGroupYear}
                                        />
                                        <ScopeTwoEmissionsFacilities
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            companyId={companyId}
                                            groupId={activeGroupId}
                                            year={activeGroupYear}
                                        />
                                        <ScopeThreeEmissionsFacilities
                                            openAccordion={subAccordion}
                                            changeAccordion={changeSubAccordion}
                                            companyId={companyId}
                                            groupId={activeGroupId}
                                            year={activeGroupYear}
                                        />
                                    </Box>
                                </Grid>
                            }
                        </Grid>
                    </DataAccordion>
                </Box>
            </Box>
        </Box>
    );
}

/**
 * Component to ease up dashboard button styling.
 * @param {Object} props 
 * @param {string} props.title Heading text, displayed above the buttons.
 * @param {string[]} props.array Array containing the button text.
 * @param {string} props.selected State to check against if the button was clicked.
 * @param {() => void} props.setSelected Function to update state when clicked.
 * @returns {JSX.Element}
 */
function DashboardSelectionButtons({ title, array, selected, setSelected }) {
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', flexWrap: 'wrap', gap: 1 }}>
            <Divider />
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', flexWrap: 'wrap', gap: 1 }}>
                <Typography variant='h6'>{title}:</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                    {Array.isArray(array) && array.map((arrayItem, index) => (
                        <Button
                            key={index}
                            variant={selected === arrayItem ? 'contained' : 'outlined'}
                            size='large'
                            sx={{ width: 'fit-content' }}
                            onClick={() => {
                                setSelected(arrayItem);
                            }}
                        >
                            {arrayItem}
                        </Button>
                    )
                    )
                    }
                </Box>
            </Box>
        </Box>
    )
}